export const LOGIN_BY_ACCOUNT = 'LOGIN_BY_ACCOUNT';
export const LOGOUT = 'LOGOUT';

export const SETUSERINFO = 'SETUSERINFO';
export const CLEARCOOKIE = 'CLEARCOOKIE';
